const rm = {}

rm.trainer = {}
rm.trainer.query = '查询'
rm.trainer.reset = '重置'
rm.trainer.loading = 'Loading...'

rm.trainer.trainer = '培训师'
rm.trainer.city = '所在城市'
rm.trainer.teamClassification = '团队分类'
rm.trainer.role = '培训师角色'
rm.trainer.status = '培训师状态'
rm.trainer.tencentMeetingAccount = '是否有腾讯会议账号'
rm.trainer.Label = '培训师标签'
rm.trainer.position = '培训师职位'
rm.trainer.No = '序号'
rm.trainer.UserName = '用户ID'
rm.trainer.Name = '姓名'
rm.trainer.userCardNo = '员工号'
rm.trainer.site = '所属公司'
rm.trainer.add = '新增'
rm.trainer.update = '编辑'
rm.trainer.save = '保存'
rm.trainer.close = '关闭'
rm.trainer.see = '详情'
rm.trainer.export = '导出'
rm.trainer.active = '活动'
rm.trainer.inactive = '不活动'
rm.trainer.queryName = '用户ID/员工号/姓名'
rm.trainer.selectUser = '选择用户'
rm.trainer.namePinyin = '名的拼音'
rm.trainer.chineseName = '姓名'
rm.trainer.surPinyin = '姓的拼音'
rm.trainer.mail = '邮箱'
rm.trainer.phone = '手机'
rm.trainer.birthday = '出生日期'
rm.trainer.sex = '性别'
rm.trainer.departments = '部门'
rm.trainer.orgType = '组织类型'
rm.trainer.orgJoinDate = '加入该职位日期'
rm.trainer.trainerNo = '培训师编号'
rm.trainer.trialEndDate = '试讲结束日期'
rm.trainer.whether = '是/否'
rm.trainer.taLevel = 'TA级别'
rm.trainer.isBest = 'BEST班主任'
rm.trainer.annual = '首次工作年度'
rm.trainer.target = '年度培训目标'
rm.trainer.hierarchicalInformation = '等级信息'
rm.trainer.basicInformation = '基础信息'
rm.trainer.LabelInformation = '标签信息'
rm.trainer.briefInformation = '简介信息'
rm.trainer.labelType = '标签类别'
rm.trainer.labelContent = '标签内容'
rm.trainer.brief = '文本'
rm.trainer.userInformation = '用户信息'
rm.trainer.define = '确定'
rm.trainer.update = '编辑'
rm.trainer.check = '查看'
rm.trainer.trainerActivityStatus = '确定将培训师状态改为“活动”？'
rm.trainer.trainerInactiveStatus = '确定将培训师状态改为“不活动”？'
rm.trainer.userNameSave = '请选择用户后保存!'
rm.trainer.citySave = '所在城市不可为空!'
rm.trainer.positionSave = '培训师职位不可为空!'
rm.trainer.trainerStatusSave = '培训师状态不可为空!'
rm.trainer.groupTypeSave = '团队分类不可为空!'
rm.trainer.trainerRoleSave = '培训师角色不可为空!'
rm.trainer.taLevelSave = 'TA级别不可为空!'
rm.trainer.isBestSave = '是否为BEST班主任不可为空!'
rm.trainer.annualSave = '年度不可为空!'
rm.trainer.targetSave = '年度培训目标不可为空!'
rm.trainer.targetInteger = '年度培训目标,请输入正整数!'
rm.trainer.select = '请选择用户!'
rm.trainer.nonnegativeInteger = '请输入正整数'
rm.trainer.industryExperience = '行业经验'
rm.trainer.briefContent = '请填写行业经验或删除该文本框!'
rm.trainer.curriculumContent = '请填写主讲课程或删除该文本框!'
rm.trainer.otherContent = '请填写其他或删除该文本框!'
rm.trainer.cancelinfo = '是否确认关闭该页面!'
rm.trainer.selectUserCode = '该用户已选择，请重新选择!'
rm.trainer.companyList = '请先选择组织类型'
rm.trainer.yes = '是'
rm.trainer.no = '否'

rm.scheduling = {}
rm.scheduling.classroomAbbreviation = '教室简称'
rm.scheduling.classroomNo = '教室编号'
rm.scheduling.classroomName = '教室名称'
rm.scheduling.classroomType = '教室分类'
rm.scheduling.currentYear = '当前年度'
rm.scheduling.utilizationRate = '利用率'
rm.scheduling.annualTarget = '年度目标'
rm.scheduling.area = '面积'
rm.scheduling.maximumNumber = '最大人数'
rm.scheduling.floor = '楼层'
rm.scheduling.label = '标签'
rm.scheduling.trainingDays = '实际培训天数'
rm.scheduling.KeyWord = '关键词'
rm.scheduling.timeSlot = '选择时间'
rm.scheduling.priority = '优先级'
rm.scheduling.qualfication = '合格'
rm.scheduling.classroomPool = '教室池'
rm.scheduling.remarks = '教室池备注'

rm.trainerManage = {}
rm.trainerManage.company = '所属公司'
rm.trainerManage.teamType = '团队分类'
rm.trainerManage.name = '姓名'
rm.trainerManage.userID = '用户ID'
rm.trainerManage.currentYear = '当前年度'
rm.trainerManage.utilizationRate = '利用率'
rm.trainerManage.annualTarget = '年度目标'
rm.trainerManage.qualified = '是否合格'
rm.trainerManage.trainerPool = '培训师池'
rm.trainerManage.trainerRemarks = '培训师备注'
rm.trainerManage.trainerPoolRemarks = '培训师池备注'
rm.trainerManage.trainerLabel = '培训师标签'
rm.trainerManage.trainerType = '培训师类型'

rm.vehicle = {}
rm.vehicle.vehicleType = '车型分类'
rm.vehicle.brand = '品牌'
rm.vehicle.vin = '车辆底盘号'
rm.vehicle.affiliatedCompany = '所属公司'
rm.vehicle.affiliatedSites = '所属场地'
rm.vehicle.engineModel = '发动机型号'
rm.vehicle.utilizationRatio = '利用率'
rm.vehicle.annualTarget = '年度目标'
rm.vehicle.priority = '优先级'
rm.vehicle.vehiclePool = '车辆池'
rm.vehicle.vehiclePoolRemarks = '车辆池备注'
rm.vehicle.label = '标签'
rm.vehicle.remarks = '车辆备注'
rm.vehicle.newVin = '请选择替换新车辆！'
rm.vehicle.download = '请选择开始时间！'

rm.talentpool = {}
rm.talentpool.name = '姓名'
rm.talentpool.inputName = '请输入姓名'
rm.talentpool.jobCode = '职位名称'
rm.talentpool.originalPosition = '原职位'
rm.talentpool.pleaseSelectDict = '请选择'
rm.talentpool.isRecommended = '原HR推荐'
rm.talentpool.queryBut = '查询'
rm.talentpool.originalDealer = '原经销商'
rm.talentpool.pleaseEnterTheLastActiveDistributor = '请输入最后在职经销商'
rm.talentpool.intentionToCity = '工作地点'
rm.talentpool.userType = '人才来源'
rm.talentpool.rest = '重置'
rm.talentpool.workYear = '工作年限'
rm.talentpool.year = '年'
rm.talentpool.bmwYear = '宝龄'
rm.talentpool.bmwYearss = '宝龄(年)'
rm.talentpool.packUp = '收起'
rm.talentpool.advancedSearch = '高级搜索'
rm.talentpool.export = '下载'
rm.talentpool.gender = '性别'
rm.talentpool.leaveDate = '离职日期'
rm.talentpool.totalInternetVisits = '全网浏览次数'
rm.talentpool.totalNumberDownloads = '全网下载次数'
rm.talentpool.latestDownloadDate = '您最近下载日期'
rm.talentpool.hrEmail = '原经销商HR联系方式'
rm.talentpool.joinTalentpoolDate = '最新加入人才库时间'
rm.talentpool.operate = '操作'
rm.talentpool.examine = '查看'
rm.talentpool.resumeDownload = '简历下载'
rm.talentpool.disagree = '不同意'
rm.talentpool.agree = '同意'
rm.talentpool.resume = '个人简历'
rm.talentpool.resume1 = '简历'
rm.talentpool.basicInfo = '基本信息'
rm.talentpool.nationality = '国籍'
rm.talentpool.native = '籍贯'
rm.talentpool.nationName = '民族'
rm.talentpool.birthday = '出生日期'
rm.talentpool.idType = '证件类型'
rm.talentpool.idNum = '证件编号'
rm.talentpool.mail = '邮箱'
rm.talentpool.phone = '手机'
rm.talentpool.wechatNo = '微信号'
rm.talentpool.education = '最高学历'
rm.talentpool.firstWorkYear = '参加工作年份'
rm.talentpool.bmwJoinDate = '服务宝马网络开始日期'
rm.talentpool.orgName = '最近所属经销商网点'
rm.talentpool.majorPositions = '当前主要职位'
rm.talentpool.networkJoinDate = '最近加入经销商网点日期'
rm.talentpool.workJoinDate = '加入经销商网点日期'
rm.talentpool.registeredResidenceName = '户口所在省份/城市'
rm.talentpool.liveName = '目前居住省份/城市'
rm.talentpool.workYears = '工龄'
rm.talentpool.workYearsss = '工龄(年)'
rm.talentpool.personalValuation = '个人评价'
rm.talentpool.workExperience = '工作经历'
rm.talentpool.startDate = '开始时间'
rm.talentpool.endDate = '结束时间'
rm.talentpool.industryName = '所属行业'
rm.talentpool.brandCode = '品牌'
rm.talentpool.brandCodeName = '品牌名称'
rm.talentpool.company = '公司'
rm.talentpool.job = '职位'
rm.talentpool.jobDescription = '工作描述与职责'
rm.talentpool.certified = '所获认证'
rm.talentpool.certificateName = '证书名称'
rm.talentpool.selectCertificateName = '选择证书'
rm.talentpool.certificateNameLevel = '证书等级'
rm.talentpool.gradeName = '认证级别'
rm.talentpool.yearGained = '获得年份'
rm.talentpool.educationalBackground = '教育背景'
rm.talentpool.school = '学校'
rm.talentpool.educationName = '学历'
rm.talentpool.major = '专业'
rm.talentpool.intentionalJobsName = '意向职位'
rm.talentpool.personalSkills = '个人技能'
rm.talentpool.languageSkills = '语言技能'
rm.talentpool.drivingSkills = '驾驶技能'
rm.talentpool.computerSkills = '计算机技能'
rm.talentpool.otherSkills = '其他技能'
rm.talentpool.queryDataIsEmpty = '查询数据为空！'
rm.talentpool.exportError = '查询数据超过两万条，不允许下载！'
rm.talentpool.sort = '排序'
rm.talentpool.modifyParentPositions = '修改父级职位'
rm.talentpool.uploadLimit = '上传文件数量超过限制！'
rm.talentpool.uploadFileFormat = '只能上传jpg/png文件！'
rm.talentpool.uploadDepIconLimit = '上传文件大小不能超过 5MB！'
rm.talentpool.sortIsNotEmpty = '排序值不能为空！'
rm.talentpool.sortMustNumber = '排序值必须为大于0的正整数！'
rm.talentpool.standardValueIsNotEmpty = '参考值不能为空！'
rm.talentpool.standardValueMustNumber = '参考值必须为大于0的正整数！'
rm.talentpool.modifyParentDep = '修改父级部门'
rm.talentpool.organizationalLevelOne = '组织架构一级'
rm.talentpool.organizationalLevelTwo = '组织架构二级'
rm.talentpool.queryUserByOutlet = '按网点查看人员信息'
rm.talentpool.exportPositionInfo = '下载空岗信息'
rm.talentpool.suggestPeopleNum = '参考人数'
rm.talentpool.actualPeopleNum = '实际人数'
rm.talentpool.kongGangNum = '空岗人数'
rm.talentpool.annualFiling = '年度归档'
rm.talentpool.createDate = '生成时间'
rm.talentpool.takeAway = '取消'
rm.talentpool.selectOutlet = '请选择网点'
rm.talentpool.exportOrgPic = '下载组织架构图'
rm.talentpool.exportUserInfo = '下载人员信息'
rm.talentpool.edit = '编辑'
rm.talentpool.editGroup = '编辑分组'
rm.talentpool.groupName = '小组名称：'
rm.talentpool.dissolve = '解散'
rm.talentpool.userId = '用户ID'
rm.talentpool.sure = '确 定'
rm.talentpool.saveSuccess = '保存成功！'
rm.talentpool.operateSuccess = '操作成功！'
rm.talentpool.noSelectGroupMember = '未选择组员！'
rm.talentpool.groupNameIsNotEmpty = '小组名称不能为空！'
rm.talentpool.userNotAllowGroup = '该人员不允许分组！'
rm.talentpool.exportChromeCheck = '超出了chrome浏览器的最大面积或宽高，请尝试调低缩放比例。'
rm.talentpool.exportFirefoxCheck = '超出了火狐浏览器的最大面积或宽高，请尝试调低缩放比例。'
rm.talentpool.exportIeCheck = '超出了IE浏览器的最大面积或宽高，请尝试调低缩放比例。'
rm.talentpool.userInfoPic = '人员信息'
rm.talentpool.organizationChart = '组织架构图'
rm.talentpool.downloadScale = '下载缩放比例：'
rm.talentpool.downloadInstructionsOne = '数据格式：1～500的正整数。'
rm.talentpool.downloadInstructionsTwo = '说明：数字越大，图片越清晰。'
rm.talentpool.temporarilyNoData = '暂无数据'
rm.talentpool.loadingIn = '加载中...'
rm.talentpool.excel = '请选择导入文件！'
rm.talentpool.jobApplication = '与申请岗位相关管理经验'
rm.talentpool.automotiveRelatedExperience = '汽车行业相关经验'
rm.talentpool.selectJobAutomotive = '列出与工作相关的证书、培训、或课程。'
rm.talentpool.certifications = '请列出您获得的与工作相关的认证或奖励。'
rm.talentpool.activities = '列出与工作相关的外部活动和团体(民间或专业团体、兴趣爱好、休闲娱乐等) ; 并陈述为什么这些活动与工作有关。'

rm.vehicleAllocation = {}
rm.vehicleAllocation.status = '调配单状态'
rm.vehicleAllocation.deploymentNo = '调配单号'
rm.vehicleAllocation.originalPlace = '始发地'
rm.vehicleAllocation.conflictOfferingNos = '冲突的排期编号'
rm.vehicleAllocation.destinationPlace = '目的地'
rm.vehicleAllocation.applicantName = '申请人'
rm.vehicleAllocation.transportDateS = '运输开始时间'
rm.vehicleAllocation.transportDateS1 = '运输开始时间起'
rm.vehicleAllocation.transportDateS2 = '运输开始时间止'
rm.vehicleAllocation.transportDateE = '运输结束时间'
rm.vehicleAllocation.transportDateE1 = '运输结束时间起'
rm.vehicleAllocation.transportDateE2 = '运输结束时间止'
rm.vehicleAllocation.noticeTime = '通知时间'
rm.vehicleAllocation.noticeTimeS = '通知时间起'
rm.vehicleAllocation.noticeTimeE = '通知时间止'
rm.vehicleAllocation.deploymentReason = '调配原因'
rm.vehicleAllocation.vehicleNo = '车辆底盘号'
rm.vehicleAllocation.courseCode = '课程编号'
rm.vehicleAllocation.applyTime = '申请时间'
rm.vehicleAllocation.add = '创建调配单'
rm.vehicleAllocation.notice = '通知'
rm.vehicleAllocation.warehousing = '入库'
rm.vehicleAllocation.batchExport = '批量调配导入模板'
rm.vehicleAllocation.batchImport = '批量调配导入'
rm.vehicleAllocation.offeringNo = '排期编号'
rm.vehicleAllocation.courseCode = '课程编号'
rm.vehicleAllocation.courseNameCn = '课程名称'
rm.vehicleAllocation.courseCatalogName = '课程分类'
rm.vehicleAllocation.offeringDateS = '开始时间'
rm.vehicleAllocation.offeringDateE = '结束时间'

rm.vehicleAllocation.arrangeType = '安排类型:'
rm.vehicleAllocation.courseDateE = '开始时间:'
rm.vehicleAllocation.courseDateS = '结束时间:'
rm.vehicleAllocation.courseStieInfo = '上课场地:'
rm.vehicleAllocation.nextCourseCode = '课程编号:'
rm.vehicleAllocation.vehicleTransportDateS = '开始时间'
rm.vehicleAllocation.vehicleTransportDateE = '结束时间'
rm.vehicleAllocation.keyWords = '关键字'
rm.vehicleAllocation.classQuaty = '本场地台数'
rm.vehicleAllocation.planOriginalPlace = '预计始发地'

rm.vehicleAllocation.delete = '删除'
rm.vehicleAllocation.establish = '创建'
rm.vehicleAllocation.noEstablish = '不创建'
rm.vehicleAllocation.update = '编辑'
rm.vehicleAllocation.recall = '撤回'
rm.vehicleAllocation.batchRevoke = '批量删除'
rm.vehicleAllocation.returnAdd = '归还申请'
rm.vehicleAllocation.columnBtn = '车辆调配信息'
rm.vehicleAllocation.ATTemplateExport = '车辆调配导入模板'

rm.vehicleAllocation.date = '选择时间'
rm.vehicleAllocation.courseSelect = '请先选择目的地!'
rm.vehicleAllocation.vehicleSelect = '请先选择运输开始时间和结束时间!'
rm.vehicleAllocation.comparisonTime = '运输结束时间不能早于运输开始时间!'
rm.vehicleAllocation.selectDestinationPlace = '请选择目的地!'
rm.vehicleAllocation.selectCourse = '请选择课程!'
rm.vehicleAllocation.selectVehicleInfo = '请选择车辆!'
rm.vehicleAllocation.selectVehicleInfoSatisfy = '请确认该车是否满足运输要求!'
rm.vehicleAllocation.selectTransportDateE = '运输结束时间应在课程的最早的开始之前!'
rm.vehicleAllocation.selectData = '请选择数据!'
rm.vehicleAllocation.selectNotice = '请选择状态为:已提交或已通知的数据，进行通知!'
rm.vehicleAllocation.selectStorage = '请选择状态为:已通知的数据，进行入库!'
rm.vehicleAllocation.selectTransportDateS = '运输开始日期请选择不能早于当前的日期!'
rm.vehicleAllocation.compareDate = '运输开始日期不能晚于运输结束日期!'
rm.vehicleAllocation.reSelectionCouron = '修改场地后，需要重新选择课程和车辆，请确认是否继续？'
rm.vehicleAllocation.reSelectionVehicle = '修改排期后，需要重新选择车辆，请确认是否继续？'
rm.vehicleAllocation.deleteCouron = '由于排期信息为空，将修改调配原因为“非课程需要”，请确定是否继续？'
rm.vehicleAllocation.deleteScheduled = '是否确定要删除该排期？'
rm.vehicleAllocation.selectionVehicle = '选择车辆'
rm.vehicleAllocation.sameVenue = '该车辆所属场地与目的地一致，调配原因自动变为“调配归还”！'
rm.vehicleAllocation.isConflict = '有冲突的调配单不允许通知！'
rm.vehicleAllocation.schedulingConflicts = '该车辆后续还有课程安排，请确认是否需要归还该调配车辆？'
rm.vehicleAllocation.deploymentConflict = '该车辆后续还有别的运输安排，此调配单提交后可能会影响该运输安排的始发地，请确认是否需要归还该调配车辆？'
rm.vehicleAllocation.isSave = '该车运输时间内有其他安排！'

rm.registerOffering = {}
rm.registerOffering.isJoinWaitingList = '排期已经满员，是否加入等候名单？'
rm.registerOffering.join = '加入'
rm.registerOffering.cancel = '取消'
rm.registerOffering.tips = '排期已满员并且未开启等候名单，不允许同意!'

export default rm
